import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@/App";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axiosInstance.post("/auth/forgot-password", { email });
      setEmailSent(true);
      toast.success("Se o email existir, um link de reset será enviado");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao solicitar reset de senha");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="w-full max-w-md">
        <Card className="shadow-2xl border-0">
          <CardHeader>
            <div className="flex items-center gap-2 mb-2">
              <button
                onClick={() => navigate('/login')}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <ArrowLeft className="w-5 h-5" />
              </button>
              <CardTitle className="text-2xl">Esqueci minha senha</CardTitle>
            </div>
            <CardDescription>
              {emailSent 
                ? "Verifique seu email para continuar" 
                : "Digite seu email para receber o link de reset"}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {emailSent ? (
              <div className="space-y-4">
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3">
                  <Mail className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                  <div className="text-sm text-blue-800">
                    <p className="font-medium mb-1">Email enviado!</p>
                    <p>
                      Se o email <strong>{email}</strong> estiver cadastrado, 
                      você receberá um link para redefinir sua senha.
                    </p>
                    <p className="mt-2">
                      O link é válido por <strong>1 hora</strong>.
                    </p>
                  </div>
                </div>
                
                <Button
                  onClick={() => navigate('/login')}
                  className="w-full"
                  variant="outline"
                >
                  Voltar para Login
                </Button>
                
                <button
                  onClick={() => {
                    setEmailSent(false);
                    setEmail("");
                  }}
                  className="w-full text-sm text-blue-600 hover:text-blue-700 hover:underline"
                >
                  Enviar para outro email
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                  <p className="text-xs text-gray-500">
                    Digite o email associado à sua conta
                  </p>
                </div>
                
                <Button
                  type="submit"
                  className="w-full bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700"
                  disabled={loading}
                >
                  {loading ? "Enviando..." : "Enviar link de reset"}
                </Button>
                
                <Button
                  type="button"
                  onClick={() => navigate('/login')}
                  className="w-full"
                  variant="outline"
                >
                  Cancelar
                </Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
